import { gql } from 'apollo-angular';

export const GET_DECLARANT_RATES = gql`
  query getDeclarantRates($company: String!, $id_declarant: Int) {
    getDeclarantRates(company: $company, id_declarant: $id_declarant) {
      id
      id_declarant
      id_type
      value
      uvt
    }
  }
`;

export const GET_DECLARANT_RATE = gql`
  query getDeclarantRate($company: String!, $id: Int!) {
    getDeclarantRate(company: $company, id: $id) {
      id
      id_declarant
      id_type
      value
      uvt
    }
  }
`;
